import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import {AppliedIrrigationData, LastAppliedIrrigation} from "../types/domain/appliedIrrigation";
import {Dayjs} from "dayjs";

export const bulkCreateAppliedIrrigation = async (body: AppliedIrrigationData): Promise<void> => {
    //If the parent date is set the backend uses this date and ignore the dates on field level.
    //That's why we also remove them from the postbody
    //If you want to use dates on field level make sure that body.date is undefined
    const _body = JSON.parse(JSON.stringify(body)) as AppliedIrrigationData;
    if (_body.date) {
        _body.fields.forEach((field) => {
            delete field.date;
        });
    }

    return await apiClient
        .post<AppliedIrrigationData>("/applied-irrigations", _body)
        .then(() => undefined)
        .catch(handleAxiosError);
};

export const getLastAppliedIrrigation = async (companyId: string, date: Dayjs): Promise<LastAppliedIrrigation[]> => {
    return await apiClient
        .get<LastAppliedIrrigation[]>(
            `/applied-irrigations/${companyId}${date ? `?date=${date.format("YYYY-MM-DD")}` : ""}`,
        )
        .then((res) => res.data)
        .catch(handleAxiosError);
};
